import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { injectStripe } from 'react-stripe-elements';
import { bindActionCreators, compose } from 'redux';
import get from 'lodash/get';
import values from 'lodash/values';
import { isEngagementValid, dayIsInPast } from '../../shared/utils';
import { getActiveUser } from '../../shared/redux/selectors';

import {
  loadCampaign,
  loadBrand,
  loadAgency,
  loadPaymentMethodsForAgency,
  updateCampaign,
  updateAgency,
  loadEngagementsForCampaign,
  submitCampaign,
  createPaymentMethod,
  validatePromoCode,
  loadPromoCode,
  validatePromoCodeForAgency,
  loadRetailers,
  loadPublishersForCampaign,
  updatePublishersForCampaign,
  loadCampaignReach,
  loadAgencyWithChildren,
  loadIOSForAgency
} from '../../shared/redux/entities/actions';

import {
  loadAccountHistory,
  removeFundsFromCampaignToAgency,
  addFundsToCampaignFromAgency,
  addFundsToCampaignDirectly,
  addFundsToAgency,
  removeFundsFromCampaignDirectly
} from '../../shared/redux/accounting/actions';

import {
  showNotification
} from '../../shared/redux/notifications/actions';

import {
  loadListOfStates,
  loadListOfStatesAndDMAs
} from '../../shared/redux/audience/actions';

import { alphabeticallySort } from '../../shared/utils';

const NATIONWIDE_STATECODE = '__NATION_WIDE__',
  FRESH_GROCER_STATECODE = '__FRESH_GROCER__',
  SHOPRITE_STATECODE = '__SHOPRITE__';

function getInvalidEngagementIndexes(state,campaignId){
  const engagements = getEngagementsForCampaign(state,campaignId);
  return engagements.reduce((invalids,e,index) => {
    if(!isEngagementValid(e)){
      return invalids.concat(index)
    } else{
      return invalids
    }
  },[]);
}

function getRetailers(state){
  return values(state.entities.companies)
    .filter((c) => !c.isBrand && c.name && c.name.length > 0)
    .filter((r) => r.name && r.name.length > 0)
    .sort((a,b) => alphabeticallySort(a.name,b.name))
}


function areAllRequiredFieldsFilled(state,props, campaignId){
  const activeCampaign = get(state,['entities','campaigns',campaignId],null);

  if(!activeCampaign) return false;

  return (activeCampaign.feedImageURL || '').length > 0
    && activeCampaign.completionText && activeCampaign.completionText.replace(/<\/?[^>]+(>|$)/g, "").trim().length > 0
    && (activeCampaign.name || '').length > 0
    && activeCampaign.launchDate
    && !dayIsInPast(activeCampaign.endDate)
    && (activeCampaign.lifetimeBudget || 0) >= 50
    && (activeCampaign.paymentMethodId || activeCampaign.paymentMethodId === "");
}

function getEngagementsForCampaign(state,campaignId){
  if(campaignId){
    return values(state.entities.engagements)
      .filter((e) => e.campaignId === campaignId)
      .sort((a,b) => a.ordinal - b.ordinal);

  } else {
    return [];
  }
}

function getPaymentMethodsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.paymentMethods)
      .filter((p) => p.agencyId === agencyId);

  } else {
    return [];
  }
}

function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId,
    activeCampaign = get(state,['entities','campaigns',campaignId],{}),
    activeAgency = get(state,['entities','agencies',activeCampaign.agencyId],{}),
    activeBrand = get(state,['entities','companies',activeCampaign.companyId],{}),
    activeUser = getActiveUser(state);
  const transfers = get(state,['accounting','accounts',activeCampaign.agencyId,'history'],[])
      .filter((a) => a.toAccountId === activeCampaign.agencyId && (a.kind === 'adjoy' || a.kind === 'invoice'))
      .sort((a,b) => b.lastModifiedDate - a.lastModifiedDate);
  const ios = values(get(state,['entities','ios'],[])).filter(io => io.accountId === activeCampaign.agencyId)
      .sort((a,b) => b.createdDate - a.createdDate)
  return {
    campaignId:campaignId,
    isCreate:campaignId === 'new',
    IsActiveUserProvider:get(activeUser,['isProvider'],true),
    isCampaignEditable:campaignId === 'new' || activeCampaign.status === 'draft',
    needsActiveUser:activeUser === null,
    activeUser:activeUser,
    activeCampaign:activeCampaign,
    activeAgency:activeAgency,
    activeBrand:activeBrand,
    activeEngagements:getEngagementsForCampaign(state,activeCampaign.id),
    activePaymentMethods:getPaymentMethodsForAgency(state,activeCampaign.agencyId),
    activePaymentMethod:get(state,['entities','paymentMethods',activeCampaign.paymentMethodId],{}),
    activeAgencyPaymentMethod:get(state,['entities','paymentMethods',activeAgency.defaultPaymentMethodId]),
    allRequiredFieldsFilled:areAllRequiredFieldsFilled(state,props, activeCampaign.id),
    activePromoCode:get(state,['entities','promoCodes',activeCampaign.promoCodeId],{}),
    invalidEngagementIndexes:getInvalidEngagementIndexes(state,activeCampaign.id),
    campaignAccountingBalance:get(state,['accounting','accounts',activeCampaign.id,'balance']),
    agencyAccountingBalance:get(state,['accounting','accounts',activeCampaign.agencyId,'balance']),
    retailers:getRetailers(state),
    transfers: transfers,
    ios:ios,
    possibleStates:state.audience.states,
    possibleGeoFilters:state.audience.geofilters
  };
}
function mapDispatchToProps(dispatch){
  return bindActionCreators({
    createPaymentMethod,
    loadCampaign,
    loadEngagementsForCampaign,
    submitCampaign,
    updateCampaign,
    loadBrand,
    loadRetailers,
    loadAgency,
    loadPaymentMethodsForAgency,
    showNotification,
    validatePromoCode,
    validatePromoCodeForAgency,
    loadPromoCode,
    loadAccountHistory,
    removeFundsFromCampaignToAgency,
    addFundsToCampaignFromAgency,
    addFundsToAgency,
    addFundsToCampaignDirectly,
    removeFundsFromCampaignDirectly,
    updateAgency,
    loadPublishersForCampaign,
    updatePublishersForCampaign,
    loadListOfStates,
    loadCampaignReach,
    loadListOfStatesAndDMAs,
    loadAgencyWithChildren,
    loadIOSForAgency
  },dispatch);
}

export default compose(
  injectStripe,
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignReview/connect.js